import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { formatDataToPieGraphPerGroup } from 'helpers/GraphHelpers';

import PieGraphFull from 'components/StatisticalGraphs/containers/PieGraphFull';

const PieGraphMarketProduct = ( {
  gId = 1,
  graphHeight = '315px',
  title = 'LAPTOPMARKET',
  hoverTitle,
  dataKey = 'lastsUnitSales',
  marketProductData,
  loading,
  error,
  children,
  locale,
} ) => {
  const [dataToGraph, setDataToGraph] = useState( {} );

  useEffect( () => {
    const formatData = formatDataToPieGraphPerGroup(
      marketProductData && marketProductData.data,
      dataKey,
    );
    if ( JSON.stringify( dataToGraph ) !== JSON.stringify( formatData ) ) {
      setDataToGraph( formatData );
    }
  }, [locale.locale, marketProductData, dataKey, dataToGraph] );

  return (
    <PieGraphFull
      {...{
        title,
        loading,
        error,
        hoverTitle,
        children,
      }}
      height={graphHeight}
      htmlId={`pie_chart_market_product_${gId}`}
      data={dataToGraph.data}
    />
  );
};

const mapStateToProps = ( { products, settings }, { categoryId } ) => {
  if ( !categoryId ) {
    return {
      marketProductData: undefined,
      loading: true,
      error: null,
      locale: settings.locale,
    };
  }
  const product = products.marketProducts.byCategoryId[categoryId];
  if ( !product ) {
    return {
      marketProductData: undefined,
      loading: false,
      error: null,
      locale: settings.locale,
    };
  }
  return {
    marketProductData: product.data,
    loading: product.loading,
    error: product.error,
    locale: settings.locale,
    // activeSessionId: user && user.activeSession && user.activeSession.id,
  };
};

export default connect( mapStateToProps )( injectIntl( PieGraphMarketProduct ) );
